import pluralize from "pluralize"

import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { InvoiceCountBadgeProps } from "./InvoiceCountBadge.types"

const icon = faIcon({ name: "circle-dollar", style: "regular" })

export default function InvoiceCountBadge(props: InvoiceCountBadgeProps) {
    const { count, tooltip, size = "md" } = props

    const label = `${count} ${pluralize("invoice", count)}`

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={tooltip ?? label}>
            {label}
        </Badge>
    )
}
